export default __webpack_public_path__ + "static/media/Word-personaje-principal.758c4485.png";